function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#262223"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.36 4h-4V1a1 1 0 00-1-1H4.64a1 1 0 00-1 1v17.9a1 1 0 001 1h4v3a1 1 0 001 1h9.64a1 1 0 001-1V5.07A1 1 0 0019.36 4zM8.69 5v11.52h-4V2.06h9.64V4H9.72a1 1 0 00-1 1.07zm10.67 15.56H9.72V6.1h9.64z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.54 11.22a2.8 2.8 0 102.8 2.8 2.8 2.8 0 00-2.8-2.8zm1.05 3l-1.21.88a.28.28 0 01-.45-.23v-1.74a.28.28 0 01.45-.23l1.21.88a.28.28 0 01.07.39l-.07.07z"
}));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24.01"
  }, props), _ref);
};

export default SvgComponent;